import { AppMenu } from 'components/uikit/menu/AppMenu';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import { useMemo } from 'react';
import styles from './StatusDropdown.module.scss';
import statusStyles from '../statusItem/StatusItem.module.scss';
import { Status } from 'services/api/api-client';

export type StatusDropdownProps = {
  statusAnchorRef: HTMLElement | null;
  isOpen: boolean;
  onClose: (selectedStatus?: Status) => void;
};

export const StatusDropdown: React.FC<StatusDropdownProps> = (props) => {
  const statusName = useScopedTranslation(
    'Page.Projects.ProjectDetailsPage.Status',
  );

  const statusItems = useMemo(() => {
    return [
      {
        key: 'draft',
        text: statusName.t('DocumentStatus.Draft'),
        className: statusStyles.draftStatus,
        onClick: () => {
          props.onClose(Status.Draft);
        },
      },
      {
        key: 'ready_review',
        text: statusName.t('DocumentStatus.ReadyForReview'),
        className: statusStyles.readyStatus,
        onClick: () => {
          props.onClose(Status.ReadyForReview);
        },
      },
      {
        key: 'can_sign',
        text: statusName.t('DocumentStatus.CanBeSigned'),
        className: statusStyles.canSignStatus,
        onClick: () => {
          props.onClose(Status.CanBeSigned);
        },
      },
      {
        key: 'not_applicable',
        text: statusName.t('DocumentStatus.NotApplicable'),
        className: statusStyles.notApplicableStatus,
        onClick: () => {
          props.onClose(Status.NotApplicable);
        },
      },
      {
        key: 'signed',
        text: statusName.t('DocumentStatus.Signed'),
        className: statusStyles.signedStatus,
        onClick: () => {
          props.onClose(Status.Signed);
        },
      },
    ];
  }, [statusName]);

  return (
    <AppMenu
      data-test-id="status-dropdown"
      className={styles.statusDropdown}
      anchorEl={props.statusAnchorRef}
      open={props.isOpen}
      onClose={() => props.onClose()}
      menuItems={statusItems}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    />
  );
};
